<template>
  <v-btn
    block
    x-large
    height="56"
    :loading="loading"
    :disabled="disabled || loading"
    class="payment-btn white--text"
    @click="$emit('click')"
    elevation="2"
  >
    <span class="text-h6 font-weight-bold letter-spacing-1">
      {{ buttonText }}
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'PaymentButton',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonText: { type: String, default: 'Pay Now' },
  },
}
</script>

<style lang="scss" scoped>
.payment-btn {
  background-color: #635bff !important; /* Stripe Blurple */
  border-radius: 4px;
  text-transform: none;
  transition: all 0.2s ease;

  &:hover {
    background-color: #544de6 !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(99, 91, 255, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
}

.letter-spacing-1 {
  letter-spacing: 0.5px;
}
</style>
